import { Box } from '@zillow/constellation';
import React from 'react';

import AuthorCard from './AuthorCard';
import type { AuthorSidebarProps } from './AuthorPage.types';

/**
 * Sidebar for the author page, displaying the author card on large screens.
 *
 * @param sidebarTop - The CSS top value for the sticky sidebar (e.g., '$spacing.xl', '80px'). Defaults to '$spacing.xl'.
 */
const AuthorSidebar: React.FC<AuthorSidebarProps> = ({
    author,
    sidebarTop = '$spacing.xl',
}) => (
    <Box
        data-testid="author-sidebar"
        sx={{
            display: 'none',
            '@media $lg': {
                display: 'block',
                width: '210px',
                flexShrink: 0,
                position: 'sticky',
                marginBottom: '$spacing.lg',
                top: sidebarTop,
                alignSelf: 'flex-start',
                marginTop: '-359px', // Only sidebar overlaps header
            },
            '@media $xl': {
                width: '300px',
            },
        }}
    >
        <AuthorCard author={author} />
    </Box>
);

export default AuthorSidebar;
